import React from 'react';
import { GOOGLE_API_CLIENT_ID, GOOGLE_REDIRECT_URI, GOOGLE_REST_API_KEY } from '../../../../constants/url';

import googleImg from '../../../../images/common/btn_google.svg';

const GoogleLogin = () => {

    return (
        <button data-login="google" title="구글 아이디로 로그인 하기" onClick={() => {
            console.log(GOOGLE_REST_API_KEY);
            const googleAuthUrl = `https://accounts.google.com/o/oauth2/v2/auth?client_id=${GOOGLE_API_CLIENT_ID}&redirect_uri=${GOOGLE_REDIRECT_URI}&response_type=code&scope=openid email`;
            window.location.href = googleAuthUrl;
        }}>
            <img src={googleImg} alt="구글 로그인" />
        </button>
    );
};

export default GoogleLogin;